import React from 'react'

import { useMainQueryData } from './useMainQueryData'

export const useMainQueryBrands = () => {
  const surveyGroup = useMainQueryData()

  return React.useMemo(() => surveyGroup?.brands ?? [], [surveyGroup?.brands])
}
